import React, {createRef, RefObject} from 'react'

import quickAdd_createEmbed from "../../../../../app/quick-add/sections/structure/embed/helpers/create-embed"
import ControlButtonStandard, {ControlButtonType} from "../../../../../core/gd-components/buttons/control-button/control-button-standard"
import {NavigationMenuInlineAddParams} from "../../menu-add-with-popover/popover"
import {EmbedTypeConfigs} from "../../../../../core/gd/const/embed/embed-type-config"
import InputInlineEditable from "../../../../../core/gd-components/input-inline-editable/input-inline-editable"

type Props = {
    level?          : number
    parentId?       : ID
    params          : NavigationMenuInlineAddParams

    onAdded         : {(isAdded:boolean):void}
}

const debug = false
// const debug = "NavigationMenuItemAddEmbed"

export default class NavigationMenuItemAddEmbed extends React.Component<Props> {

    static defaultProps = {
        level: 0
    }

    private value   : string = ''
    private inputRef: RefObject<any> = createRef<any>()

    componentDidMount() {
        this.value = ''
        this.inputRef.current.focus()
    }

    onImmediateChange = (newValue: string) => {
        this.value = newValue
    }

    onChange = async (value?:string) => {
        // do nothing if no title
        if (!value) {
            this.props.onAdded(false)
            return
        }

        debug && console.log(debug, 'onChange', value)

        const project = await quickAdd_createEmbed({
            parentProject   : this.props.parentId,
            name            : value,
            color           : gd.session.projects.get(this.props.parentId)?.color,
            projectIcon     : EmbedTypeConfigs[this.props.params.embedType!]?.projectIcon,
            embedType       : this.props.params.embedType!
        })

        this.props.onAdded(true)

        gd.goTo(project!.url)
    }

    onConfirm = () => {
        this.inputRef.current.commit()
    }

    onCancel = () => {
        this.onChange()
    }

    render() {
        debug && console.log(debug, 'render')

        const classes = Classes('item project', 'level-'+this.props.level)

        const iconClasses = Classes("gd-project-type-icon icon", EmbedTypeConfigs[this.props.params.embedType!]?.icon)

        return (
            <div className={classes}>
                <div className="row">
                    <div className="arrow hidden closed"/>
                    <div className={iconClasses}/>

                    <InputInlineEditable ref                = {this.inputRef}
                                         className          = "gd-input small name w-100-percent p-r-60"
                                         focusOnMount       = {true}
                                         value              = {this.value}
                                         autoSaveChanges    = {false}
                                         onImmediateChange  = {this.onImmediateChange}
                                         onChange           = {this.onChange}/>

                    <div className="actions flex-row-left-center">
                        <ControlButtonStandard className    = "blue-bg fs-11 m-r-3"
                                               type         = {ControlButtonType.OK}
                                               size         = {20}
                                               onClick      = {this.onConfirm}/>
                        <ControlButtonStandard className    = "hover-bg fs-11"
                                               type         = {ControlButtonType.CLOSE}
                                               size         = {20}
                                               onClick      = {this.onCancel}/>
                    </div>
                </div>
            </div>
        );
    }
}